import * as React from 'react'
import Scratch from '../../components/Scratch/Scratch'
import './eataly_styles_christmas.scss'
import EatalyLogoContainer, { eatalySnowflake } from './EatalyLogoContainer'
import { FunctionComponent, useState } from 'react'

interface Props {
  onScratchComplete: () => void
  getPrizeLabel: () => { label: string; blur: boolean }
  callBack1Percent?: number
  callBack1?: () => void
}

interface State {
  eatalyScratchCardContainer: any | null
}

const EatalyScratchCardChristmas: FunctionComponent<Props> = (props) => {
  const [eatalyScratchCardContainer, setEatalyScratchCardContainer] =
    useState<HTMLDivElement | null>(null)

  const renderPrizeLabel = () => {
    const res = props.getPrizeLabel()
    const size = 22
    return (
      <span
        className={`sc-prize-label ${res.blur ? 'sc-prize-blur' : ''}`}
        style={{ fontSize: size }}
      >
        {res.label}
      </span>
    )
  }

  let width = 0
  let height = 0

  if (eatalyScratchCardContainer) {
    width = Math.trunc(eatalyScratchCardContainer.clientWidth * 0.8)
    height = Math.trunc(width / IMG_GIFTS_EATALY_WIDTH_HEIGHT_RATIO)
  }

  return (
    <>
      <EatalyLogoContainer
        text="Choisissez votre cadeau et grattez-le !"
        smallTopContainer={false}
        displaySnowflakesForSubtitle={false}
      />

      <div className="eat-overlay">
        <img
          src={eatalySnowflake}
          className="eat-sf-bottom-right"
          alt={'snowflake'}
        />
        <img
          src={eatalySnowflake}
          className="eat-sf-bottom-left"
          alt={'snowflake'}
        />
      </div>

      <div
        className="eat-scratch-container-christmas"
        ref={(ref) =>
          !eatalyScratchCardContainer && setEatalyScratchCardContainer(ref)
        }
      >
        <Scratch
          key={`sc-eat-${width}-${height}`}
          width={width}
          height={height}
          image={`${IMG_GIFT_BASE_URL_EATALY}/contain=${
            width * window.devicePixelRatio
          }x${height * window.devicePixelRatio}/quality=100`}
          finishPercent={60}
          onComplete={props.onScratchComplete}
          customCheckZone={{
            x: width * 0.1,
            y: height * 0.3,
            width: width * 0.8,
            height: height * 0.7,
          }}
          callback1Percent={props.callBack1Percent}
          callback1={props.callBack1}
          fadeOutOnComplete={true}
          //phase={this.props.scratchCardPhase}
        >
          <div
            style={{
              width: width,
              height: height,
              backgroundColor: '#ddd',
              maskMode: 'match-source',

              maskImage: `url(${IMG_GIFT_BASE_URL_EATALY}/contain=${width}x${height}/quality=100)`,
              maskRepeat: 'no-repeat',
              maskSize: 'contain',

              WebkitMaskImage: `url(${IMG_GIFT_BASE_URL_EATALY}/contain=${width}x${height}/quality=100)`,
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskSize: 'contain',
            }}
          />
          <div className="sc-prize-label-container sc-christmas-prize-label-container-eataly">
            {renderPrizeLabel()}
          </div>
        </Scratch>
      </div>
    </>
  )
}

export default EatalyScratchCardChristmas

// export default class EatalyScratchCardChristmas extends React.Component<Props, State> {

//
//   render() {
//
//     let width = 0
//     let height = 0
//
//     if (this.state.eatalyScratchCardContainer) {
//       width = Math.trunc(this.state.eatalyScratchCardContainer.clientWidth * 0.8)
//       height = Math.trunc(width / IMG_GIFTS_EATALY_WIDTH_HEIGHT_RATIO)
//     }
//
//     return (<>
//
//       <EatalyLogoContainer text="Choisissez votre cadeau et grattez-le !" smallTopContainer={false}
//                            displaySnowflakesForSubtitle={false}/>
//
//       <div className="eat-overlay">
//         <img src={eatalySnowflake} className="eat-sf-bottom-right" alt={'snowflake'}/>
//         <img src={eatalySnowflake} className="eat-sf-bottom-left" alt={'snowflake'}/>
//       </div>
//
//       <div className="eat-scratch-container-christmas"
//            ref={ref => !this.state.eatalyScratchCardContainer && this.setState({eatalyScratchCardContainer: ref})}>
//         <Scratch
//           key={`sc-eat-${width}-${height}`}
//           width={width}
//           height={height}
//           image={`${IMG_GIFT_BASE_URL_EATALY}/contain=${width * window.devicePixelRatio}x${height * window.devicePixelRatio}/quality=100`}
//           finishPercent={60}
//           onComplete={this.props.onScratchComplete}
//           customCheckZone={{
//             x: width * 0.1,
//             y: height * 0.3,
//             width: width * 0.8,
//             height: height * 0.7,
//           }}
//           callback1Percent={this.props.callBack1Percent}
//           callback1={this.props.callBack1}
//           fadeOutOnComplete={true}
//           //phase={this.props.scratchCardPhase}
//         >
//           <div
//             style={{
//               width: width,
//               height: height,
//               backgroundColor: '#ddd',
//               maskMode: 'match-source',
//
//               maskImage: `url(${IMG_GIFT_BASE_URL_EATALY}/contain=${width}x${height}/quality=100)`,
//               maskRepeat: "no-repeat",
//               maskSize: "contain",
//
//               WebkitMaskImage: `url(${IMG_GIFT_BASE_URL_EATALY}/contain=${width}x${height}/quality=100)`,
//               WebkitMaskRepeat: "no-repeat",
//               WebkitMaskSize: "contain"
//             }}
//           />
//           <div className="sc-prize-label-container sc-christmas-prize-label-container-eataly">
//             {this.renderPrizeLabel()}
//           </div>
//         </Scratch>
//
//       </div>
//
//     </>);
//   }
//
//   private renderPrizeLabel() {
//     const res = this.props.getPrizeLabel()
//     const size = 22;
//     return (
//       <span className={`sc-prize-label ${res.blur ? "sc-prize-blur" : ""}`} style={{fontSize: size}}>{res.label}</span>)
//   }
// }

const IMG_GIFT_BASE_URL_EATALY =
  'https://tootsweet.twic.pics/cdm/img/christmas/eataly_gift.png?twic=v1'
const IMG_GIFTS_EATALY_WIDTH_HEIGHT_RATIO = 2100 / 1776
